import Model from 'flarum/common/Model';

/**
 * Client-side model for a story.
 *
 * Registered so the store can resolve a notification's subject: without a
 * model for this type the notification list fails to build and renders empty,
 * even though the unread counter sees the record.
 */
export default class Story extends Model {}

Object.assign(Story.prototype, {
  type: Model.attribute('type'),
  createdAt: Model.attribute('createdAt', Model.transformDate),
  expiresAt: Model.attribute('expiresAt', Model.transformDate),
  user: Model.hasOne('user'),
});
